var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isFormVisible && !_vm.bitacoraItems.length
        ? _c("div", { staticClass: "bg-secondary-13 rounded my-3" }, [
            _c("div", { staticClass: "col-12 py-4 text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn bg-light-white w-50",
                  on: {
                    click: function($event) {
                      _vm.isFormVisible = !_vm.isFormVisible
                    }
                  }
                },
                [
                  _c("em", { staticClass: "fas fa-file-plus pr-4 text-green" }),
                  _c("span", { staticClass: "text-button-add-document" }, [
                    _vm._v(" Presione aquí para añadir bitácora ")
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm.isFormVisible
        ? _c("BitacoraForm", {
            on: {
              cancel: function($event) {
                _vm.isFormVisible = !_vm.isFormVisible
              },
              submit: _vm.handleSubmit
            }
          })
        : _vm._e(),
      _vm._l(_vm.bitacoraItems, function(item) {
        return _c("BitacoraResultRow", {
          key: item.id,
          attrs: {
            comment: item.comment,
            date: item.date,
            "file-alias": item.fileAlias,
            "file-id": item.fileId,
            filename: item.filename,
            user: item.user
          },
          on: { download: _vm.handleDownloadFile }
        })
      }),
      !_vm.isFormVisible && _vm.bitacoraItems.length
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-file-plus",
                  text: "Añadir",
                  variant: "success"
                },
                on: {
                  click: function($event) {
                    _vm.isFormVisible = !_vm.isFormVisible
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }